import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  public isLoading: BehaviorSubject<boolean> = this.localStorageService.isLoading$;

  constructor(public localStorageService: LocalStorageService) { }

  ngOnInit(): void {
  }

}
